import { atom } from "jotai";

export const isPrechargeFlowAtom = atom(false);
